module.exports = __webpack_public_path__ + "images/car.e959f838820c452e97ebe4a271d1362c.svg";